/** @jsx h */
// @flow
import { h } from 'preact';
import { styled } from 'goober';
import CustomButton from './CustomButton';
import { currencyFormat } from '../components/directives/currencyFormat';
import type { CustomButtonProps } from './CustomButton';

const ProceedContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 5px 0px 16px;
  .amountContainer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }
  .amountText {
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.2px;
    color: #636363;
  }
  .amount {
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.1px;
    color: var(--primaryCTAColor);
    margin-top: 4px;
  }
  .buttonContainer {
    flex: 1;
    max-width: 217px;
  }
  @media (max-width: 360px) {
    .buttonContainer {
      flex: 1;
      max-width: 150px;
    }
  }
`;

type Props = {
  buttonProps: CustomButtonProps,
  amount: string,
};

const AmountButtonContainer = (props: Props) => {
  const { buttonProps, amount } = props || {};
  return (
    <ProceedContainer>
      <div className='amountContainer'>
        <div className='amountText'>Amount</div>
        <div className='amount'>₹{currencyFormat(amount)}</div>
      </div>
      <div className='buttonContainer'>
        <CustomButton {...buttonProps} />
      </div>
    </ProceedContainer>
  );
};
export default AmountButtonContainer;



// WEBPACK FOOTER //
// ./UiComponents/AmountButtonContainer.js